import * as React from "react";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import { ForbiddenError, FourOhThreePage } from "./FourOhThreePage";
import { FourOhFourPage, NotFoundError } from "./FourOhFourPage";
import { usePageTitle } from "../../hooks/usePageTitle";
import { useErrorDialog } from "@tlc/ui/dialog/error/ErrorDialogContext";

export const ErrorBoundary: React.FC = () => {
  const error = useRouteError();
  const { forbiddenPageTitle, pageNotFoundPageTitle } = usePageTitle();
  const { handleRequestError } = useErrorDialog();

  if (error instanceof ForbiddenError) {
    document.title = forbiddenPageTitle;
    return <FourOhThreePage />;
  }

  if (error instanceof NotFoundError) {
    document.title = pageNotFoundPageTitle;
    return <FourOhFourPage />;
  }

  if (
    (isRouteErrorResponse(error) &&
      (error.status === 403 || error.status === 404)) ||
    (error instanceof Response &&
      (error.status === 403 || error.status === 404))
  ) {
    if (error.status === 403) {
      document.title = forbiddenPageTitle;
      return <FourOhThreePage />;
    }
    if (error.status === 404) {
      document.title = pageNotFoundPageTitle;
      return <FourOhFourPage />;
    }
  }

  handleRequestError(error);
  return <></>;
};
